import i18n from './index';
import receipts from './moduleCopy/receipts.json';
import marketing from './moduleCopy/marketing.json';
import marketingCreative from './moduleCopy/marketingCreative.json';
import marketingFinishing from './moduleCopy/marketingFinishing.json';
import decisionWorkspace from './moduleCopy/decisionWorkspace.json';
import decisionActions from './moduleCopy/decisionActions.json';
import decisionBridge from './moduleCopy/decisionBridge.json';
import marketingGuided from './moduleCopy/marketingGuided.json';
import distribution from './moduleCopy/distribution.json';
import inventory from './moduleCopy/inventory.json';
import cigar from './moduleCopy/cigar.json';
import derick from './moduleCopy/derick.json';
import supportPrompts from './moduleCopy/supportPrompts.json';
import dashboard from './moduleCopy/dashboard.json';
import hr from './moduleCopy/hr.json';
import payroll from './moduleCopy/payroll.json';
import clientPortal from './moduleCopy/clientPortal.json';
import email from './moduleCopy/email.json';
import tms from './moduleCopy/tms.json';
import tmsOperations from './moduleCopy/tmsOperations.json';
import tmsRouting from './moduleCopy/tmsRouting.json';
import tmsQuotes from './moduleCopy/tmsQuotes.json';
import tmsDispatch from './moduleCopy/tmsDispatch.json';
import credits from './moduleCopy/credits.json';
import reliability from './moduleCopy/reliability.json';
import financePosting from './moduleCopy/financePosting.json';
import marketingExisting from '../modules/marketing/marketingEs419Copy';
import cigarExisting from '../modules/cigar-retail/cigarRetailEs419Copy';
import decisionExisting from '../components/managerialEconomics/managerialEs419Copy';
import english from './locales/en/translation.json';
import spanish from './locales/es-419/translation.json';

function collectCopy(source, target, output = {}) {
  Object.keys(source).forEach(key => {
    if (typeof source[key] === 'string' && typeof target?.[key] === 'string') {
      output[source[key]] = target[key];
    } else if (source[key] && typeof source[key] === 'object') {
      collectCopy(source[key], target?.[key], output);
    }
  });
  return output;
}
const copy = Object.freeze({
  ...decisionWorkspace,
  ...decisionActions,
  ...decisionBridge,
  ...collectCopy(english, spanish), ...tms, ...tmsOperations, ...tmsRouting, ...tmsQuotes, ...tmsDispatch, ...credits, ...marketingExisting, ...cigarExisting,
  ...decisionExisting, ...marketing, ...distribution, ...inventory, ...cigar, ...derick, ...supportPrompts, ...dashboard, ...marketingCreative, ...marketingFinishing, ...receipts, ...marketingGuided, ...payroll, ...hr, ...clientPortal, ...email, ...reliability, ...financePosting,
});

// Call at display sites, never on user records or API identifiers. Whitespace
// around inline text is retained. Interpolated values are inserted unchanged.
export function moduleText(source, values = {}) {
  if (typeof source !== 'string') return source;
  const key = source.trim();
  const isSpanish = (i18n.resolvedLanguage || i18n.language || '').startsWith('es');
  const translated = isSpanish && Object.prototype.hasOwnProperty.call(copy, key)
    ? source.replace(key, () => copy[key]) : source;
  return translated.replace(/\{\{(\w+)\}\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
}

export function moduleLocale() {
  return (i18n.resolvedLanguage || i18n.language || '').startsWith('es') ? 'es-419' : 'en-US';
}
